<template>
  <v-app>
    <main-app-bar></main-app-bar>
    <v-main class="hk-app-bg" :style="{ backgroundImage: 'url(' + baseImg + ')' }">
      <section class="hk-section">
        <div class="hk-wrap">
          <v-row justify="center">
            <v-col cols="12" md="8" lg="6">
              <v-card class="hk-card pa-8 pa-md-12 text-center">
                <v-icon icon="mdi-hammer-wrench" size="64" color="primary" class="mb-4"></v-icon>
                <h1 class="hk-heading hk-heading--accent mb-4">Hamarosan</h1>
                <p class="hk-lead mb-8">
                  Ez az oldal még fejlesztés alatt áll. Addig is nézd meg galériánkat, vagy vedd fel velünk a kapcsolatot!
                </p>
                <div class="d-flex flex-wrap justify-center ga-3">
                  <v-btn color="primary" variant="flat" prepend-icon="mdi-image-multiple" @click="$router.push('gallery')">
                    Galéria
                  </v-btn>
                  <v-btn color="secondary" variant="outlined" prepend-icon="mdi-home" @click="$router.push('/')">
                    Főoldal
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";

@Options({
  components: {MainAppBar},
  data() {
    return {
      baseImg: require("@/assets/base.png"),
    };
  }
})
export default class References extends Vue {
}
</script>
